module.exports = __webpack_public_path__ + "img/375.2af79a00.jpg";